import './assets/main.css'

import { loadRuntimeConfig } from '@/services/runtime-config.ts'

// Runtime config (e.g. the API URL) is fetched from config.json before the app
// boots so a single build can target different environments. The rest of the
// app is imported dynamically afterwards so that modules reading the config at
// load time (axios, socket, sentry) observe the resolved values.
void loadRuntimeConfig().then(() => import('./bootstrap.ts'))
